module.exports = __webpack_public_path__ + "media/instagram/action_link_arrow-ec694396.svg";